import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { EscapeScriptPipe } from '../shared/escape-script.pipe';

@Injectable()
export class EscapeScriptInterceptor implements HttpInterceptor {
  constructor(
    private escaeScriptPipe: EscapeScriptPipe
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req);
  }
}